// Unique local content for each Columbus-area service location

export const AREAS = [
  {
    slug: "columbus",
    name: "Columbus",
    county: "Franklin County",
    seoTitle: "Home Health Care in Columbus, OH | CareFirst Home Health",
    seoDesc:
      "CareFirst Home Health provides skilled nursing, home health aide and personal care services in Columbus, Ohio. Medicare, Medicaid, PASSPORT, DODD and VA welcome.",
    intro:
      "As a locally rooted, CHAP-accredited agency headquartered in Columbus, CareFirst delivers compassionate home health care throughout Ohio's capital city.",
    body:
      "From Clintonville to the Far East Side, our caregivers and nurses help Columbus residents recover, manage chronic conditions, and remain safely independent at home. We coordinate closely with local hospitals, physicians, and case managers to make quality care easy to access.",
    highlights: [
      "Headquartered in Columbus at 6740 Huntley Rd #107",
      "Fast response for local referrals and discharges",
      "Serving all Columbus neighborhoods and ZIP codes",
    ],
  },
  {
    slug: "westerville",
    name: "Westerville",
    county: "Franklin & Delaware Counties",
    seoTitle: "Home Health Care in Westerville, OH | CareFirst Home Health",
    seoDesc:
      "Skilled nursing, home health aide and personal care in Westerville, Ohio. CareFirst Home Health serves seniors and adults with Medicare and Medicaid.",
    intro:
      "CareFirst brings trusted, personalized home health care to families throughout Westerville and the Uptown community.",
    body:
      "Our team supports Westerville seniors and adults with disabilities with skilled nursing, personal care, and everyday assistance — helping them stay comfortable in the neighborhoods they love while staying connected to local providers.",
    highlights: [
      "Serving Uptown Westerville and surrounding areas",
      "Coordination with local physicians and hospitals",
      "Flexible scheduling for families",
    ],
  },
  {
    slug: "dublin",
    name: "Dublin",
    county: "Franklin, Delaware & Union Counties",
    seoTitle: "Home Health Care in Dublin, OH | CareFirst Home Health",
    seoDesc:
      "In-home skilled nursing and personal care in Dublin, Ohio. CareFirst Home Health helps seniors recover and live independently. Referrals welcome.",
    intro:
      "Families across Dublin trust CareFirst for compassionate, professional home health care tailored to each person's needs.",
    body:
      "Whether recovering after surgery or managing a long-term condition, Dublin residents receive attentive nursing and daily-living support at home, with clear communication for families and referral partners.",
    highlights: [
      "Serving Dublin and nearby communities",
      "Post-hospital and chronic care support",
      "Trusted, background-checked caregivers",
    ],
  },
  {
    slug: "worthington",
    name: "Worthington",
    county: "Franklin County",
    seoTitle: "Home Health Care in Worthington, OH | CareFirst Home Health",
    seoDesc:
      "Home health aide, skilled nursing and companion care in Worthington, Ohio from CareFirst Home Health. Compassionate in-home care for seniors.",
    intro:
      "CareFirst provides dependable home health care to Worthington's seniors and adults with disabilities.",
    body:
      "Our caregivers help Worthington residents with everything from personal care and medication reminders to skilled nursing — supporting safe, independent living close to Old Worthington and the surrounding community.",
    highlights: [
      "Serving Old Worthington and nearby areas",
      "Personal care and companionship",
      "Medication management and nursing",
    ],
  },
  {
    slug: "gahanna",
    name: "Gahanna",
    county: "Franklin County",
    seoTitle: "Home Health Care in Gahanna, OH | CareFirst Home Health",
    seoDesc:
      "CareFirst Home Health offers skilled nursing and personal care in Gahanna, Ohio. Supporting seniors and adults with disabilities at home.",
    intro:
      "In Gahanna, CareFirst delivers personalized home care that keeps loved ones safe and comfortable at home.",
    body:
      "From the Creekside district to residential neighborhoods, our team supports Gahanna families with reliable caregiving, recovery support, and daily assistance backed by close provider coordination.",
    highlights: [
      "Serving Gahanna and Creekside area",
      "Recovery and daily-living support",
      "Coordination with case managers",
    ],
  },
  {
    slug: "reynoldsburg",
    name: "Reynoldsburg",
    county: "Franklin, Fairfield & Licking Counties",
    seoTitle: "Home Health Care in Reynoldsburg, OH | CareFirst Home Health",
    seoDesc:
      "Skilled nursing, home health aide and respite care in Reynoldsburg, Ohio. CareFirst Home Health supports safe, independent living at home.",
    intro:
      "CareFirst helps Reynoldsburg families access compassionate, professional home health care.",
    body:
      "Our caregivers assist Reynoldsburg residents with personal care, respite, and skilled nursing, helping seniors and adults with disabilities remain independent in their own homes.",
    highlights: [
      "Serving Reynoldsburg and surrounding communities",
      "Respite care for family caregivers",
      "Skilled and non-skilled services",
    ],
  },
  {
    slug: "grove-city",
    name: "Grove City",
    county: "Franklin County",
    seoTitle: "Home Health Care in Grove City, OH | CareFirst Home Health",
    seoDesc:
      "In-home care in Grove City, Ohio: skilled nursing, personal care and companionship from CareFirst Home Health. Medicare and Medicaid welcome.",
    intro:
      "Grove City families rely on CareFirst for warm, dependable home health care.",
    body:
      "We support Grove City seniors and adults near the Town Center and throughout the community with personal care, companionship, and nursing services designed around each person's goals.",
    highlights: [
      "Serving Grove City and Town Center area",
      "Companion and personal care",
      "Flexible, family-friendly scheduling",
    ],
  },
  {
    slug: "hilliard",
    name: "Hilliard",
    county: "Franklin County",
    seoTitle: "Home Health Care in Hilliard, OH | CareFirst Home Health",
    seoDesc:
      "CareFirst Home Health provides skilled nursing and personal care in Hilliard, Ohio. Compassionate in-home support for seniors and families.",
    intro:
      "CareFirst offers Hilliard residents trusted, personalized home health care close to home.",
    body:
      "Our team helps Hilliard families with recovery, chronic-condition management, and daily support — keeping loved ones safe and independent throughout Old Hilliard and nearby neighborhoods.",
    highlights: [
      "Serving Hilliard and Old Hilliard",
      "Chronic disease and recovery support",
      "Dependable, compassionate caregivers",
    ],
  },
  {
    slug: "pickerington",
    name: "Pickerington",
    county: "Fairfield & Franklin Counties",
    seoTitle: "Home Health Care in Pickerington, OH | CareFirst Home Health",
    seoDesc:
      "Skilled nursing, home health aide and respite services in Pickerington, Ohio from CareFirst Home Health. Helping seniors thrive at home.",
    intro:
      "In Pickerington, CareFirst provides compassionate home health care families can count on.",
    body:
      "We support Pickerington seniors and adults with disabilities with nursing, personal care, and respite — helping them live comfortably and safely in the Violet Township community.",
    highlights: [
      "Serving Pickerington and Violet Township",
      "Respite and personal care",
      "Skilled nursing at home",
    ],
  },
  {
    slug: "new-albany",
    name: "New Albany",
    county: "Franklin & Licking Counties",
    seoTitle: "Home Health Care in New Albany, OH | CareFirst Home Health",
    seoDesc:
      "CareFirst Home Health offers private duty nursing and personal care in New Albany, Ohio. Premium, personalized in-home care for seniors.",
    intro:
      "CareFirst brings attentive, personalized home health care to New Albany families.",
    body:
      "From private duty nursing to companionship, our caregivers help New Albany residents receive discreet, high-quality care in the comfort and privacy of their own homes.",
    highlights: [
      "Serving New Albany and nearby areas",
      "Private duty and companion care",
      "Discreet, personalized service",
    ],
  },
  {
    slug: "whitehall",
    name: "Whitehall",
    county: "Franklin County",
    seoTitle: "Home Health Care in Whitehall, OH | CareFirst Home Health",
    seoDesc:
      "Personal care, home health aide and skilled nursing in Whitehall, Ohio. CareFirst Home Health supports independent living for seniors.",
    intro:
      "CareFirst provides Whitehall residents with reliable, compassionate home health care.",
    body:
      "Our caregivers assist Whitehall seniors and adults with disabilities with daily living, personal care, and nursing support — helping them stay independent and connected to local resources.",
    highlights: [
      "Serving the Whitehall community",
      "Personal care and daily-living support",
      "Medicaid and waiver programs welcome",
    ],
  },
  {
    slug: "upper-arlington",
    name: "Upper Arlington",
    county: "Franklin County",
    seoTitle: "Home Health Care in Upper Arlington, OH | CareFirst Home Health",
    seoDesc:
      "Skilled nursing, personal care and companionship in Upper Arlington, Ohio from CareFirst Home Health. Trusted in-home care for seniors.",
    intro:
      "Upper Arlington families choose CareFirst for professional, compassionate home health care.",
    body:
      "We help Upper Arlington seniors recover, manage health conditions, and enjoy companionship at home — with attentive caregivers and clear coordination for families and providers.",
    highlights: [
      "Serving Upper Arlington neighborhoods",
      "Skilled nursing and companionship",
      "Experienced, vetted caregivers",
    ],
  },
  {
    slug: "bexley",
    name: "Bexley",
    county: "Franklin County",
    seoTitle: "Home Health Care in Bexley, OH | CareFirst Home Health",
    seoDesc:
      "CareFirst Home Health provides personal care and skilled nursing in Bexley, Ohio. Compassionate, personalized in-home support for seniors.",
    intro:
      "CareFirst offers Bexley residents warm, personalized home health care.",
    body:
      "Our caregivers support Bexley families with personal care, medication management, and nursing services — helping loved ones remain safe and independent in this close-knit community.",
    highlights: [
      "Serving the Bexley community",
      "Personal care and medication support",
      "Coordinated, family-centered care",
    ],
  },
  {
    slug: "canal-winchester",
    name: "Canal Winchester",
    county: "Franklin & Fairfield Counties",
    seoTitle: "Home Health Care in Canal Winchester, OH | CareFirst Home Health",
    seoDesc:
      "Home health aide, respite and skilled nursing in Canal Winchester, Ohio. CareFirst Home Health helps seniors live safely and independently at home.",
    intro:
      "CareFirst delivers dependable home health care to Canal Winchester families.",
    body:
      "We help Canal Winchester seniors and adults with disabilities with nursing, respite, and daily assistance — supporting comfortable, independent living throughout the community.",
    highlights: [
      "Serving Canal Winchester and nearby areas",
      "Respite and daily-living support",
      "Skilled nursing at home",
    ],
  },
];

export const getArea = (slug) => AREAS.find((a) => a.slug === slug);
